module.exports = __webpack_public_path__ + "f3c0ec3f1fa681ff583a9c2427bdd244.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/booking_holdings_2023_chart.png
// module id = 1641
// module chunks = 0